import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { SubmitContactQueryRequest } from '@property/shared';
import { captureMutationError } from '@/lib/sentry';
import { toast, showMutationErrorToast } from '@/lib/toast';

export function useSubmitContactQuery() {
  return useMutation({
    mutationFn: (request: SubmitContactQueryRequest) => api.submitContactQuery(request),
    onSuccess: () => {
      toast.success('Your message has been sent. We will get back to you soon.');
    },
    onError: (error) => {
      captureMutationError(error, { mutation: 'useSubmitContactQuery' });
      showMutationErrorToast(error, 'Failed to send message. Please try again.');
    },
  });
}
